import { render, staticRenderFns } from "./ResearchStatementComponent.vue?vue&type=template&id=f3eb87c2&scoped=true&"
import script from "./ResearchStatementComponent.vue?vue&type=script&lang=js&"
export * from "./ResearchStatementComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3eb87c2",
  null
  
)

export default component.exports